export const styles = {
  presets: {
    marginLeft: '10px',
  },
  group: {
    minHeight: 42,
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/Presets/styles.js